<template>
<div class="sezione"  >

  <div class="row"> 
    <div class="col s4 m2"><img src="../assets/logo.png" style="height:70px;"/></div>
    <div class="col s8 m10"><h2>{{$socio.contatto.row.cognome}} {{$socio.contatto.row.nome}}</h2> </div>
  </div>

        
<div class="title_h1 yo-color-primary" style="margin-top:30px;">RICHIESTA DI ISCRIZIONE COMPLETATA CORRETTAMENTE</div>
<br />
Le confermiamo che la procedura d'iscrizione è andata a buon fine.
<br /><br />
Le chiediamo gentilmente di inviare <!-- copia dell'avvenuto pagamento di € 90,00 e --> la scheda firmata 
<!-- eliminato il 18 Novembre
(con la firma dei due soci presentatori regolarmente iscritti alla {{$socio.sigla}} da almeno 5 anni) al seguente numero di fax 02 45498199 
-->
a seguito della quale le invieremo regolare ricevuta tramite e-mail.
<br /><br />
<a :href="'http://diventasocio.biomedia.net/pdfs/'+$socio.sigla.toLowerCase()+'/'+$socio.contatto.row.id+'.pdf'" target="_blank">Scarica ora la scheda da firmare</a>
<!--
<br />
Il numero identificativo da indicare unitamente alla copia dell'avvenuto pagamento è: <b>{{$contatto.row.id}}</b>
-->
<br /><br />
Le comunichiamo inoltre che la sua iscrizione dovrà essere avvallata dal Consiglio Direttivo della {{$socio.sigla}} nella sua prossima riunione, sarà cura della Segreteria inviarle conferma  dell'accettazione appena ci sarà comunicato.
<br /><br />
Cordiali saluti
<br /><br />
Segreteria {{$socio.sigla}}<br />
Tel: 0245498282
<!--  eliminato il 18 Novembre 2025
<br />Fax: 0245498199
-->
<br /><br />


  </div>
</template>

<script>

export default {
  components: {
  },
  created () {
    this.$axios.get('https://diventasocio.biomedia.net/'+$socio.sigla.toLowerCase()+'/schedaesterna/id/'+this.$socio.contatto.row.id)
   }
}
</script>


<style scoped>
  .home{
    background:#fff;
    min-height:600px;
    padding:20px;
  }
</style>
